import React, { useEffect, useState } from 'react'
import './Go_to_Top.css'
import Lottie from 'react-lottie'
import * as animationData from './Go_to_Top.json'

const Go_to_Top = () => {

    const [showButton, setShowButton] = useState(false)

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    }

    // Scroll to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    // Show button after scrolling down
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setShowButton(true)
            } else {
                setShowButton(false)
            }
        }

        window.addEventListener("scroll", handleScroll)

        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    return (
        <>
            {showButton && (
                <div className='Go_to_Top' onClick={scrollToTop}>
                    <Lottie
                        className="lotties"
                        options={defaultOptions}
                    />
                </div>
            )}
        </>
    )
}

export default Go_to_Top